window.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".site-nav__view-archive-link")?.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector(".hc-lookbook-archive-link")?.click();
  });
  
  /* Collection filters */
  const filters = document.querySelector(".hc-lookbook-filters");
  const grid = document.querySelector(".hc-lookbook-grid");
  grid.insertBefore(filters, document.querySelector(".hc-lookbook-images"));

  document.querySelectorAll(".hc-lookbook-images").forEach((item, index) => {
    if(index > 0) {
      const parentSection = item.closest(".shopify-section");
      grid.appendChild(item);
      item.classList.add("hc-hide");
      parentSection?.remove();
    }
  });

  function clearLookbookLinkActive() {
    document.querySelectorAll(".hc-lookbook-filters li.hc-lookbook-link").forEach(item => {
      item.classList.remove("hc-lookbook-active");
    });
  }

  function clearLookbookGridImages() {
    document.querySelectorAll(".hc-lookbook-images").forEach(item => {
      item.style = "";
    });
  }

  document.querySelectorAll(".hc-lookbook-filters li.hc-lookbook-link").forEach((item) => {
    item.addEventListener("click", () => {
      clearLookbookLinkActive();
      const attribute = item.getAttribute("data-name").toLowerCase();
      const parentAll = document.querySelector(".hc-lookbook-page");
      parentAll.querySelectorAll(`.hc-lookbook-images`).forEach((img, index) => {
        const imgAttribute = img.getAttribute("data-name").toLowerCase();
        if(imgAttribute == attribute) {
          parentAll.classList.remove("active");
          setTimeout(() => {
            item.classList.add("hc-lookbook-active");
            parentAll.classList.add("active");
            parentAll.setAttribute("data-name", attribute);
            if(document.querySelector(`.hc-lookbook-link[data-name="${attribute}"]`).hasAttribute("data-hide")){
              parentAll.querySelector("h1").innerText = `${attribute}`; // Archive - 
            } else {
              parentAll.querySelector("h1").innerText = attribute;
            }
            img.classList.remove("hc-hide");
            pagination();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }, 50);
        } else {
          setTimeout(() => {
            img.classList.add("hc-hide");
            pagination();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }, 50);
        }
      });

      const parentOfAll = document.querySelector(".hc-lookbook-page");
      if(!item.hasAttribute("data-hide")) {
        document.querySelector(".hc-lookbook-archive-link").style.display = "block";
        parentOfAll.classList.remove("showing-archive");
        hideLinkWithHideData(true);
      } else {
        document.querySelector(".hc-lookbook-archive-link").style.display = "none";
        parentOfAll.classList.add("showing-archive");
        hideLinkWithHideData(false);
      }
    });
  });

  function hideLinkWithHideData(show) {
    document.querySelectorAll(".hc-lookbook-filters li.hc-lookbook-link[data-hide]").forEach((item) => {
      if (!show) {
        item.classList.remove("hc-lookbook-link__hide");
      } else {
        item.classList.add("hc-lookbook-link__hide");
      }
    });
  }

  pagination();
  function pagination() {
    document.querySelector(".hc-lookbook-pagination")?.remove();
    const activeLookbook = document.querySelector(`.hc-lookbook-images:not(.hc-hide)`);
    const previousActiveLookbook = activeLookbook?.previousElementSibling;
    const nextActiveLookbook = activeLookbook?.nextElementSibling;
    let prevLookbookImage;
    let nextLookbookImage;

    if(previousActiveLookbook && previousActiveLookbook.classList.contains("hc-lookbook-images")) {
      prevLookbookImage = previousActiveLookbook.getAttribute("data-name");
    }
    if(nextActiveLookbook && nextActiveLookbook.classList.contains("hc-lookbook-images")) {
      nextLookbookImage = nextActiveLookbook.getAttribute("data-name");
    }

    const hcLookbookPageSection = document.querySelector(".hc-lookbook-page");
    const paginationContainer = document.createElement("div");
    const pagination = document.createElement("div");
    hcLookbookPageSection.appendChild(paginationContainer);
    paginationContainer.classList.add("hc-lookbook-pagination-container");
    pagination.classList.add("hc-lookbook-pagination");
    paginationContainer.appendChild(pagination);

    if(nextLookbookImage && !prevLookbookImage) {
      pagination.style = "justify-content: flex-end;";
    }

    let hcHtml = ``;
    if(prevLookbookImage) {
      hcHtml += `<button class="hc-pagination-change" data-pagination-name="${prevLookbookImage}">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 12.1 23.8" xml:space="preserve">
          <g>
            <polygon points="11.3,23.8 0,12.1 11.3,0 12.1,0.7 1.4,12.1 12,23.1  "/>
          </g>
        </svg>
        ${prevLookbookImage}
      </button>`;
    }
    if(nextLookbookImage) {
      hcHtml += `<button class="hc-pagination-change" data-pagination-name="${nextLookbookImage}">
        ${nextLookbookImage}
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 12.1 23.8" xml:space="preserve">
          <g>
            <polygon points="0.7,23.8 0,23.1 10.7,12.1 0,0.7 0.7,0 12.1,12.1  "/>
          </g>
        </svg>
      </button>`;
    }
    pagination.innerHTML = hcHtml;
    paginationEvent();
  }
  
  function paginationEvent() {
    const currentEvent = document.querySelectorAll(".hc-pagination-change");
    currentEvent.forEach((item) => {
      item.addEventListener("click", () => {
        const paginationName = item.getAttribute("data-pagination-name");
        const target = document.querySelector(`.hc-lookbook-link[data-name="${paginationName}"]`);
        if(target) {
          if(target.classList.contains("hc-lookbook-link__hide")) {
            document.querySelector(".hc-lookbook-archive-link").click();
          }
          target.click();
        }
      });
    });
  }

  const archiveLink = document.querySelector(".hc-lookbook-archive-link");
  archiveLink.addEventListener("click", () => {
    clearLookbookLinkActive();
    archiveLink.style.display = "none";
    const firstElementInArchive = document.querySelector(".hc-lookbook-link.hc-lookbook-link__hide");
    firstElementInArchive.click();
    const parentAll = grid.parentElement;
    parentAll.classList.add("showing-archive");
    document.querySelectorAll(".hc-lookbook-link.hc-lookbook-link__hide").forEach(item => {
      item.classList.remove("hc-lookbook-link__hide");
    });
  });

  function clearModalInView() {
    document.querySelectorAll(".hc-lookbook-modal").forEach(item => {
      item.classList.remove("hc-lookbook-modal-open");
      item.removeAttribute("role");
      item.removeAttribute("aria-modal");
      const hcCardElement = item.previousElementSibling;
      if(hcCardElement) {
        hcCardElement.setAttribute("aria-expanded", "false");
      }
    });
  }

  modal();
  function modal() {
    let touchstartX;
    let touchendX;
    const closeButton = document.querySelector(".hc-modal-close");
    const modalBackground = document.querySelector(".hc-lookbook-modal-back");
  
    const hcLookbookCard = document.querySelectorAll(".hc-lookbook-images-child");
    hcLookbookCard.forEach(item => {
      item.addEventListener("click", () => {
        clearModalInView();
        item.setAttribute("aria-expanded", "true");
        const modalOfCard = item.nextElementSibling;
        if(modalOfCard.classList.contains("hc-lookbook-modal")) {
          modalOfCard.classList.add("hc-lookbook-modal-open");
          modalBackground.style.display = "block";
          modalOfCard.setAttribute("role", "dialog");
          modalOfCard.setAttribute("aria-modal", "true");
        }
      });
    });

    document.querySelectorAll(".hc-modal-share").forEach(item => {
      item.addEventListener("click", () => {
        item.querySelector(".hc-modal-share__icons").classList.toggle("inline-flex");
      });
    });

    closeButton.addEventListener("click", () => {
      clearModalInView();
      modalBackground.style.display = "none";
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        clearModalInView();
        if(modalBackground) {
          modalBackground.style.display = "none";
        }
      }
    }); 
  
    const prevArrow = document.querySelectorAll(".hc-prev-arrow");
    const nextArrow = document.querySelectorAll(".hc-next-arrow");
  
    prevArrow.forEach(arrow => {
      arrow.addEventListener("click", () => {
        const currentModal = arrow.closest(".hc-lookbook-modal");
        const prevModal = currentModal?.previousElementSibling?.previousElementSibling;
        if(prevModal) {
          clearModalInView();
          prevModal.classList.add("hc-lookbook-modal-open");
        }
      });
    });
  
    nextArrow.forEach(arrow => {
      arrow.addEventListener("click", () => {
        const currentModal = arrow.closest(".hc-lookbook-modal");
        const nextModal = currentModal?.nextElementSibling?.nextElementSibling;
        if(nextModal) {
          clearModalInView();
          nextModal.classList.add("hc-lookbook-modal-open");
        }
      });
    });

    /* Mobile modal swapper */
    document.querySelectorAll(".hc-lookbook-modal .hc-modal-image-arrow-container").forEach((item) => {
      const slidePrevArrow = item.querySelector(".hc-prev-arrow");
      const slideNextArrow = item.querySelector(".hc-next-arrow");
      item.addEventListener('touchstart', function(event) {
        touchstartX = event.changedTouches[0].screenX;
      });
      
      item.addEventListener('touchend', function(event) {
        touchendX = event.changedTouches[0].screenX;
        const minDistance = 50;
        const distance = touchendX - touchstartX;
      
        if (Math.abs(distance) >= minDistance) {
          if (distance > 0) {
            slidePrevArrow.click();
          } else {
            slideNextArrow.click();
          }
        }
      });
      touchstartX = null;
      touchendX = null;
    });
  }

  /* Redirections and autoclicks when entering the lookbook page */
  const urlParams = new URLSearchParams(window.location.search);
  const isArchiveView = urlParams.has('option') && urlParams.get('option') === 'archive';

  const isCollectionView = urlParams.has('option');

  if(isCollectionView && !isArchiveView) {
    const newUrlParsed = urlParams.get('option').replaceAll("--", " ");
    const collectionBtn = document.querySelectorAll('.hc-lookbook-link');
    collectionBtn.forEach(item => {
      if(item.getAttribute("data-name") == newUrlParsed) {
        item.click();
      }
    });

    //urlParams.delete('option');
    const newUrl = window.location.pathname;
    //window.history.replaceState({}, document.title, newUrl);
  }
  

  if (isArchiveView) {
    const archiveBtn = document.querySelector('.hc-lookbook-archive-link');
    if (archiveBtn) {
      archiveBtn.click();
    }

    //urlParams.delete('option');
    const newUrl = window.location.pathname;
    //window.history.replaceState({}, document.title, newUrl);
  }

  /* HC - Remove loader, show grid - 27 Feb '24 */
  const lookbookPageSelector = document.querySelector(".hc-lookbook-page");
  const lookbookPageFilters = document.querySelector(".hc-lookbook-filters");
  lookbookPageSelector.classList.remove("hide");
  lookbookPageFilters.classList.remove("hide");
  document.querySelector("div.hc-loader")?.remove();
});
